/*

Tailwind - The Utility-First CSS Framework

A project by Adam Wathan (@adamwathan), Jonathan Reinink (@reinink),
David Hemphill (@davidhemphill) and Steve Schoger (@steveschoger).

Welcome to the Tailwind config file. This is where you can customize
Tailwind specifically for your project. Don't be intimidated by the
length of this file. It's really just a big JavaScript object and
we've done our very best to explain each section.

View the full documentation at https://tailwindcss.com.


|-------------------------------------------------------------------------------
| The default config
|-------------------------------------------------------------------------------
|
| This variable contains the default Tailwind config. You don't have
| to use it, but it can sometimes be helpful to have available. For
| example, you may choose to merge your custom configuration
| values with some of the Tailwind defaults.
|
*/

// let defaultConfig = require('tailwindcss/defaultConfig')()

/*
|-------------------------------------------------------------------------------
| Colors                                    https://tailwindcss.com/docs/colors
|-------------------------------------------------------------------------------
|
| Here you can specify the colors used in your project. To get you started,
| we've provided a generous palette of great looking colors that are perfect
| for prototyping, but don't hesitate to change them for your project. You
| own these colors, nothing will break if you change everything about them.
|
| We've used literal color names ("red", "blue", etc.) for the default
| palette, but if you'd rather use functional names like "primary" and
| "secondary", or even a numeric scale like "100" and "200", go for it.
|
*/
let colors = {};
[
  {
    name : 'primary',
    colors : ['hsla(213, 90%, 10%, 1.00)','hsla(213, 95%, 25%, 1.00)','hsla(213, 95%, 35%, 1.00)','hsla(213, 100%, 59%, 1.00)','hsla(213, 100%, 70%, 1.00)','hsla(213, 100%, 83%, 1.00)','hsla(213, 100%, 93%, 1.00)']
  },
  {
    name : 'secondary',
    colors : ['hsla(342, 55%, 10%, 1.00)','hsla(342, 65%, 25%, 1.00)','hsla(342, 65%, 38%, 1.00)','hsla(342, 75%, 57%, 1.00)','hsla(342, 75%, 65%, 1.00)','hsla(342, 75%, 80%, 1.00)','hsla(342, 85%, 93%, 1.00)']
  },
  {
    name : 'grey',
    colors : ['hsla(213, 40%, 10%, 1.00)','hsla(213, 30%, 18%, 1.00)','hsla(202, 20%, 28%, 1)','hsla(213, 15%, 54%, 1.00)','hsla(213, 15%, 72%, 1.00)','hsla(213, 15%, 85%, 1.00)','hsla(213, 15%, 95%, 1.00)']
  },
  {
    name : 'red',
    colors : ['hsla(0, 90%, 12%, 1.00)','hsla(0, 80%, 25%, 1.00)','hsla(0, 80%, 48%, 1.00)','hsla(0, 99%, 64%, 1.00)','hsla(0, 99%, 71%, 1.00)','hsla(0, 99%, 83%, 1.00)','hsla(0, 99%, 93%, 1.00)']
  },
  {
    name : 'green',
    colors : ['hsla(143, 69%, 10%, 1.00)','hsla(143, 79%, 20%, 1.00)','hsla(143, 79%, 30%, 1.00)','hsla(143, 79%, 45%, 1.00)','hsla(143, 75%, 55%, 1.00)','hsla(143, 75%, 70%, 1.00)','hsla(143, 80%, 80%, 1.00)']
  },
  {
    name : 'yellow',
    colors : ['hsla(20, 90%, 20%, 1.00)','hsla(30, 100%, 30%, 1.00)','hsla(40, 100%, 40%, 1.00)','hsla(46, 100%, 57%, 1.00)','hsla(46, 95%, 69%, 1.00)','hsla(46, 95%, 79%, 1.00)','hsla(46, 90%, 92%, 1.00)']
  },
  {
    name : 'orange',
    colors : ['#520E00','#773200','#A15500','#CE7900','#FCA035','#FFB190']
  },
  {
    name : 'purple',
    colors : ['#9242FD','#B15FFF','#D17BFF','#F197FF','#FFB4FF','#BBA1D4']
  },
  {
    name : 'pink',
    colors : ['#5F006D','#84008F','#AA00B3','#D12DD7','#F85AFD','#FFF5FF']
  }
].map(({name,colors}) => {
  const levels = ['-darkest','-darker','-dark','','-light','-lighter','-lightest'];
  const colorlevels = {};
  colors.forEach( (color,key) => {
    colorlevels[`${name}${levels[key]}`] = color
  });

  return colorlevels;
}).forEach(shade => {
  colors = {...colors,...shade};
});

const pageRelativeWidths = {
  1: '0.25rem',
  2: '0.5rem',
  3: '0.75rem',
  4: '1rem',
  6: '1.5rem',
  8: '2rem',
  10: '2.5rem',
  12: '3rem',
  16: '4rem',
  24: '6rem',
  32: '8rem',
  48: '12rem',
  64: '16rem'
};
const absoluteWidths = {
  '10px': '10px',
  '20px': '20px',
  '40px': '40px',
  '60px': '60px',
  '80px': '80px',
  '100px': '100px',
  '125px': '125px',
  '150px': '150px',
  '175px': '175px',
  '200px': '200px',
  '250px': '250px',
  '300px': '300px',
  '350px': '350px',
  '400px': '400px',
  '450px': '450px',
  '500px': '500px',
  '550px': '550px',
  '600px': '600px',
  '650px': '650px',
  '700px': '700px',
  '750px': '750px',
  '800px': '800px',
  '850px': '850px',
  '900px': '900px',
  '950px': '950px',
  '1000px': '1000px'
};
const parentRelativeWidths = {
  '1/7': '14.29%',
  '1/6': '16.66667%',
  '1/5': '20%',
  '1/4': '25%',
  '1/3': '33.33333%',
  '2/5': '40%',
  '1/2': '50%',
  '3/5': '60%',
  '2/3': '66.66667%',
  '3/4': '75%',
  '4/5': '80%',
  '5/6': '83.33333%',
  '6/7': '85.71%',
  '7/7': '100%'
};
const pageRelativeHeights = {
  1: '0.25rem',
  2: '0.5rem',
  3: '0.75rem',
  4: '1rem',
  6: '1.5rem',
  8: '2rem',
  10: '2.5rem',
  12: '3rem',
  16: '4rem',
  24: '6rem',
  32: '8rem',
  48: '12rem',
  64: '16rem',
  128: '32rem',
  '100%': '100vh'
};
const absoluteheights = {
  '50px': '50px',
  '100px': '100px',
  '150px': '150px',
  '200px': '200px',
  '250px': '250px',
  '300px': '300px',
  '350px': '350px',
  '400px': '400px',
  '450px': '450px',
  '500px': '500px',
  '600px': '600px',
  '700px': '700px',
  '800px': '800px',
  '900px': '900px',
  '1000px': '1000px'
};
const parentRelativeHeights = { half: '50%', full: '100%' };

module.exports = {
  /*
    |-----------------------------------------------------------------------------
    | Colors                                  https://tailwindcss.com/docs/colors
    |-----------------------------------------------------------------------------
    |
    | The color palette defined above is also assigned to the "colors" key of
    | your Tailwind config. This makes it easy to access them in your CSS
    | using Tailwind's config helper. For example:
    |
    | .error { color: config('colors.red') }
    |
    */

  colors,

  /*
    |-----------------------------------------------------------------------------
    | Screens                      https://tailwindcss.com/docs/responsive-design
    |-----------------------------------------------------------------------------
    |
    | Screens in Tailwind are translated to CSS media queries. They define the
    | responsive breakpoints for your project. By default Tailwind takes a
    | "mobile first" approach, where each screen size represents a minimum
    | viewport width. Feel free to have as few or as many screens as you
    | want, naming them in whatever way you'd prefer for your project.
    |
    | Tailwind also allows for more complex screen definitions, which can be
    | useful in certain situations. Be sure to see the full responsive
    | documentation for a complete list of options.
    |
    | Class name: .{screen}:{utility}
    |
    */

  screens: {
    sm: '640px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    '2xl': '1536px'
  },

  /*
    |-----------------------------------------------------------------------------
    | Fonts                                    https://tailwindcss.com/docs/fonts
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your project's font stack, or font families.
    | Keep in mind that Tailwind doesn't actually load any fonts for you.
    | If you're using custom fonts you'll need to import them prior to
    | defining them here.
    |
    | By default we provide a native font stack that works remarkably well on
    | any device or OS you're using, since it just uses the default fonts
    | provided by the platform.
    |
    | Class name: .font-{name}
    |
    */

  fonts: {
    'abeezee': ['ABeeZee', 'sans-serif'],
    'abel': ['Abel', 'sans-serif'],
    'abril-fatface': ['Abril Fatface', 'serif'],
    'acme': ['Acme', 'sans-serif'],
    'alegreya': ['Alegreya', 'serif'],
    'alegreya-sans': ['Alegreya Sans', 'sans-serif'],
    'alfa-slab-one': ['Alfa Slab One', 'display'],
    'almarai': ['Almarai', 'sans-serif'],
    'amiri-quran': ['Amiri Quran', 'serif'],
    'amatic-sc': ['Amatic SC', 'handwriting'],
    'amiri': ['Amiri', 'serif'],
    'antic-slab': ['Antic Slab', 'serif'],
    'anton': ['Anton', 'sans-serif'],
    'architects-daughter': ['Architects Daughter', 'serif'],
    'archivo': ['Archivo', 'sans-serif'],
    'archivo-black': ['Archivo Black', 'sans-serif'],
    'archivo-narrow': ['Archivo Narrow', 'sans-serif'],
    'arimo': ['Arimo', 'sans-serif'],
    'armata': ['Armata', 'sans-serif'],
    'arvo': ['Arvo', 'serif'],
    'asap': ['Asap', 'serif'],
    'assistant': ['Assistant', 'sans-serif'],
    'balsamiq-sans': ['Balsamiq Sans', 'serif'],
    'bangers': ['Bangers', 'display'],
    'barlow': ['Barlow', 'serif'],
    'barlow-condensed': ['Barlow Condensed', 'sans-serif'],
    'barlow-semi-condensed': ['Barlow Semi Condensed', 'sans-serif'],
    'bebas-neue': ['Bebas Neue', 'serif'],
    'benchnine': ['BenchNine', 'sans-serif'],
    'bitter': ['Bitter', 'serif'],
    'bree-serif': ['Bree Serif', 'serif'],
    'cabin': ['Cabin', 'serif'],
    'cabin-condensed': ['Cabin Condensed', 'sans-serif'],
    'cairo': ['Cairo', 'serif'],
    'cantarell': ['Cantarell', 'sans-serif'],
    'cardo': ['Cardo', 'serif'],
    'catamaran': ['Catamaran', 'sans-serif'],
    'caveat': ['Caveat', 'handwriting'],
    'chakra-petch': ['Chakra Petch', 'sans-serif'],
    'changa': ['Changa', 'sans-serif'],
    'chivo': ['Chivo', 'sans-serif'],
    'cinzel': ['Cinzel', 'serif'],
    'comfortaa': ['Comfortaa', 'display'],
    'concert-one': ['Concert One', 'display'],
    'cookie': ['Cookie', 'handwriting'],
    'cormorant-garamond': ['Cormorant Garamond', 'serif'],
    'courgette': ['Courgette', 'handwriting'],
    'crete-round': ['Crete Round', 'serif'],
    'crimson-pro': ['Crimson Pro', 'serif'],
    'crimson-text': ['Crimson Text', 'serif'],
    'cuprum': ['Cuprum', 'sans-serif'],
    'dancing-script': ['Dancing Script', 'serif'],
    'didact-gothic': ['Didact Gothic', 'sans-serif'],
    'dm-sans': ['DM Sans', 'sans-serif'],
    'dm-serif-display': ['DM Serif Display', 'serif'],
    'domine': ['Domine', 'serif'],
    'dosis': ['Dosis', 'sans-serif'],
    'eb-garamond': ['EB Garamond', 'serif'],
    'economica': ['Economica', 'sans-serif'],
    'exo': ['Exo', 'sans-serif'],
    'exo-2': ['Exo 2', 'sans-serif'],
    'fira-sans': ['Fira Sans', 'sans-serif'],
    'fira-sans-condensed': ['Fira Sans Condensed', 'sans-serif'],
    'fjalla-one': ['Fjalla One', 'sans-serif'],
    'francois-one': ['Francois One', 'sans-serif'],
    'frank-ruhl-libre': ['Frank Ruhl Libre', 'serif'],
    'gloria-hallelujah': ['Gloria Hallelujah', 'handwriting'],
    'great-vibes': ['Great Vibes', 'handwriting'],
    'gudea': ['Gudea', 'sans-serif'],
    'hammersmith-one': ['Hammersmith One', 'sans-serif'],
    'handlee': ['Handlee', 'handwriting'],
    'heebo': ['Heebo', 'sans-serif'],
    'hind': ['Hind', 'sans-serif'],
    'hind-madurai': ['Hind Madurai', 'sans-serif'],
    'hind-siliguri': ['Hind Siliguri', 'sans-serif'],
    'ibm-plex-mono': ['IBM Plex Mono', 'monospace'],
    'ibm-plex-sans': ['IBM Plex Sans', 'sans-serif'],
    'ibm-plex-serif': ['IBM Plex Serif', 'serif'],
    'inconsolata': ['Inconsolata', 'monospace'],
    'indie-flower': ['Indie Flower', 'sans-serif'],
    'inter': ['Inter', 'sans-serif'],
    'istok-web': ['Istok Web', 'sans-serif'],
    'josefin-sans': ['Josefin Sans', 'serif'],
    'josefin-slab': ['Josefin Slab', 'serif'],
    'jost': ['Jost', 'sans-serif'],
    'kalam': ['Kalam', 'handwriting'],
    'kanit': ['Kanit', 'sans-serif'],
    'karla': ['Karla', 'sans-serif'],
    'kaushan-script': ['Kaushan Script', 'handwriting'],
    'lato': ['Lato', 'sans-serif'],
    'libre-baskerville': ['Libre Baskerville', 'sans-serif'],
    'libre-franklin': ['Libre Franklin', 'sans-serif'],
    'lilita-one': ['Lilita One', 'display'],
    'lobster': ['Lobster', 'sans-serif'],
    'lobster-two': ['Lobster Two', 'display'],
    'lora': ['Lora', 'sans-serif'],
    'luckiest-guy': ['Luckiest Guy', 'display'],
    'm-plus-1p': ['M PLUS 1p', 'sans-serif'],
    'm-plus-rounded-1c': ['M PLUS Rounded 1c', 'sans-serif'],
    'manrope': ['Manrope', 'sans-serif'],
    'martel': ['Martel', 'sans-serif'],
    'maven-pro': ['Maven Pro', 'sans-serif'],
    'merriweather': ['Merriweather', 'sans-serif'],
    'merriweather-sans': ['Merriweather Sans', 'sans-serif'],
    'monda': ['Monda', 'sans-serif'],
    'montserrat': ['Montserrat', 'sans-serif'],
    'montserrat-alternates': ['Montserrat Alternates', 'sans-serif'],
    'mukta': ['Mukta', 'sans-serif'],
    'mulish': ['Mulish', 'sans-serif'],
    'nanum-gothic': ['Nanum Gothic', 'sans-serif'],
    'nanum-myeongjo': ['Nanum Myeongjo', 'serif'],
    'neuton': ['Neuton', 'serif'],
    'news-cycle': ['News Cycle', 'sans-serif'],
    'noticia-text': ['Noticia Text', 'serif'],
    'noto-color-emoji': ['Noto Color Emoji', 'sans-serif'],
    'noto-kufi-arabic': ['Noto Kufi Arabic', 'sans-serif'],
    'noto-sans': ['Noto Sans', 'sans-serif'],
    'noto-sans-hk': ['Noto Sans HK', 'sans-serif'],
    'noto-sans-jp': ['Noto Sans JP', 'sans-serif'],
    'noto-sans-kr': ['Noto Sans KR', 'sans-serif'],
    'noto-sans-sc': ['Noto Sans SC', 'sans-serif'],
    'noto-sans-tc': ['Noto Sans TC', 'sans-serif'],
    'noto-serif': ['Noto Serif', 'sans-serif'],
    'noto-serif-jp': ['Noto Serif JP', 'serif'],
    'nunito': ['Nunito', 'Helvetica', 'Arial', 'sans-serif'],
    'nunito-sans': ['Nunito Sans', 'Helvetica', 'Arial', 'sans-serif'],
    'old-standard-tt': ['Old Standard TT', 'Helvetica', 'Arial', 'sans-serif'],
    'open-sans': ['Open Sans', 'Helvetica', 'Arial', 'sans-serif'],
    'open-sans-condensed': ['Open Sans Condensed', 'Helvetica', 'Arial', 'sans-serif'],
    'orbitron': ['Orbitron', 'sans-serif'],
    'oswald': ['Oswald', 'sans-serif'],
    'outfit': ['Outfit', 'sans-serif'],
    'overpass': ['Overpass', 'sans-serif'],
    'oxygen': ['Oxygen', 'sans-serif'],
    'pacifico': ['Pacifico', 'sans-serif'],
    'passion-one': ['Passion One', 'display'],
    'pathway-gothic-one': ['Pathway Gothic One', 'sans-serif'],
    'patrick-hand': ['Patrick Hand', 'handwriting'],
    'patua-one': ['Patua One', 'display'],
    'paytone-one': ['Paytone One', 'sans-serif'],
    'permanent-marker': ['Permanent Marker', 'handwriting'],
    'philosopher': ['Philosopher', 'sans-serif'],
    'play': ['Play', 'sans-serif'],
    'playfair-display': ['Playfair Display', 'sans-serif'],
    'playfair-display-sc': ['Playfair Display SC', 'serif'],
    'plus-jakarta-sans': ['Plus Jakarta Sans', 'sans-serif'],
    'poiret-one': ['Poiret One', 'display'],
    'pontano-sans': ['Pontano Sans', 'sans-serif'],
    'poppins': ['Poppins', 'sans-serif'],
    'prata': ['Prata', 'serif'],
    'prompt': ['Prompt', 'sans-serif'],
    'pt-sans': ['PT Sans', 'sans-serif'],
    'pt-sans-caption': ['PT Sans Caption', 'sans-serif'],
    'pt-sans-narrow': ['PT Sans Narrow', 'sans-serif'],
    'pt-serif': ['PT Serif', 'sans-serif'],
    'public-sans': ['Public Sans', 'sans-serif'],
    'quattrocento': ['Quattrocento', 'serif'],
    'quattrocento-sans': ['Quattrocento Sans', 'sans-serif'],
    'questrial': ['Questrial', 'sans-serif'],
    'quicksand': ['Quicksand', 'sans-serif'],
    'rajdhani': ['Rajdhani', 'sans-serif'],
    'raleway': ['Raleway', 'sans-serif'],
    'red-hat-display': ['Red Hat Display', 'sans-serif'],
    'reem-kufi': ['Reem Kufi', 'sans-serif'],
    'righteous': ['Righteous', 'display'],
    'roboto': ['Roboto', 'sans-serif'],
    'roboto-condensed': ['Roboto Condensed', 'sans-serif'],
    'roboto-mono': ['Roboto Mono', 'monospace'],
    'roboto-slab': ['Roboto Slab', 'sans-serif'],
    'rokkitt': ['Rokkitt', 'serif'],
    'ropa-sans': ['Ropa Sans', 'sans-serif'],
    'rubik': ['Rubik', 'sans-serif'],
    'russo-one': ['Russo One', 'sans-serif'],
    'sacramento': ['Sacramento', 'handwriting'],
    'saira-condensed': ['Saira Condensed', 'sans-serif'],
    'sanchez': ['Sanchez', 'serif'],
    'sarabun': ['Sarabun', 'sans-serif'],
    'satisfy': ['Satisfy', 'handwriting'],
    'secular-one': ['Secular One', 'sans-serif'],
    'shadows-into-light': ['Shadows Into Light', 'handwriting'],
    'signika': ['Signika', 'sans-serif'],
    'signika-negative': ['Signika Negative', 'sans-serif'],
    'slabo-27px': ['Slabo 27px', 'serif'],
    'source-code-pro': ['Source Code Pro', 'monospace'],
    'source-sans-3': ['Source Sans 3', 'sans-serif'],
    'source-sans-pro': ['Source Sans Pro', 'sans-serif'],
    'space-grotesk': ['Space Grotesk', 'sans-serif'],
    'special-elite': ['Special Elite', 'display'],
    'tajawal': ['Tajawal', 'sans-serif'],
    'tangerine': ['Tangerine', 'handwriting'],
    'teko': ['Teko', 'sans-serif'],
    'tinos': ['Tinos', 'serif'],
    'titillium-web': ['Titillium Web', 'sans-serif'],
    'ubuntu': ['Ubuntu', 'sans-serif'],
    'ubuntu-condensed': ['Ubuntu Condensed', 'sans-serif'],
    'varela-round': ['Varela Round', 'sans-serif'],
    'volkhov': ['Volkhov', 'serif'],
    'vollkorn': ['Vollkorn', 'serif'],
    'work-sans': ['Work Sans', 'sans-serif'],
    'yanone-kaffeesatz': ['Yanone Kaffeesatz', 'sans-serif'],
    'yantramanav': ['Yantramanav', 'sans-serif'],
    'yellowtail': ['Yellowtail', 'handwriting'],
    'zilla-slab': ['Zilla Slab', 'serif']
  },
  fontsData: {
    'abril-fatface': {
      name: ['Abril Fatface', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    amatic: {
      name: ['Amatic', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'architects-daughter': {
      name: ['Architects Daughter', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    asap: {
      name: ['Asap', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'balsamiq-sans': {
      name: ['Balsamiq Sans', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    barlow: {
      name: ['Barlow', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'bebas-neue': {
      name: ['Bebas Neue', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    bitter: {
      name: ['Bitter', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    cabin: {
      name: ['Cabin', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    cairo: {
      name: ['Cairo', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'cormorant-garamond': {
      name: ['Cormorant Garamond', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'crimson-text': {
      name: ['Crimson Text', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'crimson-pro': {
      name: ['Crimson Pro', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'dancing-script': {
      name: ['Dancing Script', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'fira-sans': {
      name: ['Fira Sans', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'fjalla-one': {
      name: ['Fjalla One', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'indie-flower': {
      name: ['Indie Flower', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'josefin-sans': {
      name: ['Josefin Sans', 'serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    lato: {
      name: ['Lato', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'libre-baskerville': {
      name: ['Libre Baskerville', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'libre-franklin': {
      name: ['Libre Franklin', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    lobster: {
      name: ['Lobster', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    lora: {
      name: ['Lora', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    martel: {
      name: ['Martel', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    merriweather: {
      name: ['Merriweather', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    montserrat: {
      name: ['Montserrat', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    mukta: {
      name: ['Mukta', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'noto-sans': {
      name: ['Noto Sans', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'noto-sans-jp': {
      name: ['Noto Sans JP', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'noto-sans-kr': {
      name: ['Noto Sans KR', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'noto-serif': {
      name: ['Noto Serif', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    nunito: {
      name: ['Nunito', 'Helvetica', 'Arial', 'serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    'nunito-sans': {
      name: ['Nunito Sans', 'Helvetica', 'Arial', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    'old-standard-tt': {
      name: ['Old Standard TT', 'Helvetica', 'Arial', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    'open-sans': {
      name: ['Open Sans', 'Helvetica', 'Arial', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    'open-sans-condensed': {
      name: ['Open Sans Condensed', 'Helvetica', 'Arial', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    oswald: {
      name: ['Oswald', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    overpass: {
      name: ['Overpass', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    oxygen: {
      name: ['Oxygen', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    pacifico: {
      name: ['Pacifico', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    'playfair-display': {
      name: ['Playfair Display', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    poppins: {
      name: ['Poppins', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'pt-sans': {
      name: ['PT Sans', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'pt-sans-narrow': {
      name: ['PT Sans Narrow', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'pt-serif': {
      name: ['PT Serif', 'serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    raleway: {
      name: ['Raleway', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    roboto: {
      name: ['Roboto', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'roboto-condensed': {
      name: ['Roboto Condensed', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    'roboto-slab': {
      name: ['Roboto Slab', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700
      }
    },
    rubik: {
      name: ['Rubik', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'source-code-pro': {
      name: ['Source Code Pro', 'monospace'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'source-sans-pro': {
      name: ['Source Sans Pro', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    tajawal: {
      name: ['Tajawal', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'titillium-web': {
      name: ['Titillium Web', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    ubuntu: {
      name: ['Ubuntu', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    },
    'work-sans': {
      name: ['Work Sans', 'sans-serif'],
      weight: {
        normal: 400,
        bold: 700,
        black: 900
      }
    }
  },
  /*
    |-----------------------------------------------------------------------------
    | Text sizes                         https://tailwindcss.com/docs/text-sizing
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your text sizes. Name these in whatever way
    | makes the most sense to you. We use size names by default, but
    | you're welcome to use a numeric scale or even something else
    | entirely.
    |
    | By default Tailwind uses the "rem" unit type for most measurements.
    | This allows you to set a root font size which all other sizes are
    | then based on. That said, you are free to use whatever units you
    | prefer, be it rems, ems, pixels or other.
    |
    | Class name: .text-{size}
    |
    */

  textSizes: {
    xs: '0.75rem', // 12px
    sm: '0.875rem', // 14px
    base: '1rem', // 16px
    lg: '1.125rem', // 18px
    xl: '1.25rem', // 20px
    '2xl': '1.5rem', // 24px
    '3xl': '1.875rem', // 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem', // 48px
    '6xl': '4.5rem', // 72px
    '7xl': '6rem', // 96px
    '8xl': '9rem' // 144px
  },

  /*
    |-----------------------------------------------------------------------------
    | Font weights                       https://tailwindcss.com/docs/font-weight
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your font weights. We've provided a list of
    | common font weight names with their respective numeric scale values
    | to get you started. It's unlikely that your project will require
    | all of these, so we recommend removing those you don't need.
    |
    | Class name: .font-{weight}
    |
    */

  fontWeights: {
    hairline: 100,
    light: 300,
    normal: 400,
    semibold: 600,
    bold: 700,
    black: 900
  },

  /*
    |-----------------------------------------------------------------------------
    | Leading (line height)              https://tailwindcss.com/docs/line-height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your line height values, or as we call
    | them in Tailwind, leadings.
    |
    | Class name: .leading-{size}
    |
    */

  leading: {
    none: 1,
    tight: 1.25,
    normal: 1.5,
    loose: 2
  },

  /*
    |-----------------------------------------------------------------------------
    | Tracking (letter spacing)       https://tailwindcss.com/docs/letter-spacing
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your letter spacing values, or as we call
    | them in Tailwind, tracking.
    |
    | Class name: .tracking-{size}
    |
    */

  tracking: {
    tight: '-0.05em',
    normal: '0',
    wide: '0.05em'
  },

  /*
    |-----------------------------------------------------------------------------
    | Text colors                         https://tailwindcss.com/docs/text-color
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your text colors. By default these use the
    | color palette we defined above, however you're welcome to set these
    | independently if that makes sense for your project.
    |
    | Class name: .text-{color}
    |
    */

  textColors: colors,

  /*
    |-----------------------------------------------------------------------------
    | Background colors             https://tailwindcss.com/docs/background-color
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your background colors. By default these use
    | the color palette we defined above, however you're welcome to set
    | these independently if that makes sense for your project.
    |
    | Class name: .bg-{color}
    |
    */

  backgroundColors: colors,

  /*
    |-----------------------------------------------------------------------------
    | Background sizes               https://tailwindcss.com/docs/background-size
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your background sizes. We provide some common
    | values that are useful in most projects, but feel free to add other sizes
    | that are specific to your project here as well.
    |
    | Class name: .bg-{size}
    |
    */

  backgroundSize: {
    auto: 'auto',
    cover: 'cover',
    contain: 'contain'
  },

  /*
    |-----------------------------------------------------------------------------
    | Border widths                     https://tailwindcss.com/docs/border-width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your border widths. Take note that border
    | widths require a special "default" value set as well. This is the
    | width that will be used when you do not specify a border width.
    |
    | Class name: .border{-side?}{-width?}
    |
    */

  borderWidths: {
    default: '1px',
    0: '0',
    2: '2px',
    3: '3px',
    4: '4px',
    6: '6px',
    8: '8px'
  },

  /*
    |-----------------------------------------------------------------------------
    | Border colors                     https://tailwindcss.com/docs/border-color
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your border colors. By default these use the
    | color palette we defined above, however you're welcome to set these
    | independently if that makes sense for your project.
    |
    | Take note that border colors require a special "default" value set
    | as well. This is the color that will be used when you do not
    | specify a border color.
    |
    | Class name: .border-{color}
    |
    */

  borderColors: { default: colors['grey-light'], ...colors },

  /*
    |-----------------------------------------------------------------------------
    | Border radius                    https://tailwindcss.com/docs/border-radius
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your border radius values. If a `default` radius
    | is provided, it will be made available as the non-suffixed `.rounded`
    | utility.
    |
    | If your scale includes a `0` value to reset already rounded corners, it's
    | a good idea to put it first so other values are able to override it.
    |
    | Class name: .rounded{-side?}{-size?}
    |
    */

  borderRadius: {
    sm: '.125rem',
    default: '.25rem',
    md: '.35rem',
    lg: '.5rem',
    xl: '.75rem',
    full: '9999px'
  },

  /*
    |-----------------------------------------------------------------------------
    | Width                                    https://tailwindcss.com/docs/width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your width utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default
    | we provide a sensible rem based numeric scale, a percentage
    | based fraction scale, plus some other common use-cases. You
    | can, of course, modify these values as needed.
    |
    |
    | It's also worth mentioning that Tailwind automatically escapes
    | invalid CSS class name characters, which allows you to have
    | awesome classes like .w-2/3.
    |
    | Class name: .w-{size}
    |
    */

  width: {
    auto: 'auto',
    px: '1px',
    ...absoluteWidths,
    ...pageRelativeWidths,
    ...parentRelativeWidths,
    full: '100%',
    screen: '100vw'
  },

  // Individual categories of widths for use in Page Builder style panels
  pageRelativeWidths,
  parentRelativeWidths,
  absoluteWidths,

  /*
    |-----------------------------------------------------------------------------
    | Height                                  https://tailwindcss.com/docs/height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your height utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default
    | we provide a sensible rem based numeric scale plus some other
    | common use-cases. You can, of course, modify these values as
    | needed.
    |
    | Class name: .h-{size}
    |
    */

  height: {
    auto: 'auto',
    px: '1px',
    ...pageRelativeHeights,
    ...parentRelativeHeights,
    ...absoluteheights,
    screen: '100vh'
  },

  // Individual categories of heights for use in Page Builder style panels
  pageRelativeHeights,
  parentRelativeHeights,
  absoluteheights,

  /*
    |-----------------------------------------------------------------------------
    | Minimum width                        https://tailwindcss.com/docs/min-width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your minimum width utility sizes. These can
    | be percentage based, pixels, rems, or any other units. We provide a
    | couple common use-cases by default. You can, of course, modify
    | these values as needed.
    |
    | Class name: .min-w-{size}
    |
    */

  minWidth: {
    0: '0',
    full: '100%'
  },

  /*
    |-----------------------------------------------------------------------------
    | Minimum height                      https://tailwindcss.com/docs/min-height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your minimum height utility sizes. These can
    | be percentage based, pixels, rems, or any other units. We provide a
    | few common use-cases by default. You can, of course, modify these
    | values as needed.
    |
    | Class name: .min-h-{size}
    |
    */

  minHeight: {
    0: '0',
    half: '50%',
    full: '100%',
    screen: '100vh'
  },

  /*
    |-----------------------------------------------------------------------------
    | Maximum width                        https://tailwindcss.com/docs/max-width
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your maximum width utility sizes. These can
    | be percentage based, pixels, rems, or any other units. By default
    | we provide a sensible rem based scale and a "full width" size,
    | which is basically a reset utility. You can, of course,
    | modify these values as needed.
    |
    | Class name: .max-w-{size}
    |
    */

  maxWidth: {
    none: 'none',
    xxs: '10rem', // 160px
    xs: '20rem', // 320px
    sm: '30rem', // 480px
    md: '40rem', // 640px
    lg: '50rem', // 800px
    xl: '60rem', // 960px
    '2xl': '70rem', // 1120px
    '3xl': '80rem', // 1280px
    '4xl': '90rem', // 1440px
    '5xl': '100rem', // 1600px
    full: '100%'
  },

  /*
    |-----------------------------------------------------------------------------
    | Maximum height                      https://tailwindcss.com/docs/max-height
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your maximum height utility sizes. These can
    | be percentage based, pixels, rems, or any other units. We provide a
    | couple common use-cases by default. You can, of course, modify
    | these values as needed.
    |
    | Class name: .max-h-{size}
    |
    */

  maxHeight: {
    80: '80%',
    70: '70%',
    full: '100%',
    screen: '100vh'
  },

  /*
    |-----------------------------------------------------------------------------
    | Padding                                https://tailwindcss.com/docs/padding
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your padding utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default we
    | provide a sensible rem based numeric scale plus a couple other
    | common use-cases like "1px". You can, of course, modify these
    | values as needed.
    |
    | Class name: .p{side?}-{size}
    |
    */

  padding: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    18: '4.5rem',
    20: '5rem',
    22: '5.5rem',
    24: '6rem',
    32: '8rem',
    48: '12rem',
    64: '16rem'
  },

  /*
    |-----------------------------------------------------------------------------
    | Margin                                  https://tailwindcss.com/docs/margin
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your margin utility sizes. These can be
    | percentage based, pixels, rems, or any other units. By default we
    | provide a sensible rem based numeric scale plus a couple other
    | common use-cases like "1px". You can, of course, modify these
    | values as needed.
    |
    | Class name: .m{side?}-{size}
    |
    */

  margin: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    18: '4.5rem',
    20: '5rem',
    22: '5.5rem',
    24: '6rem',
    32: '8rem',
    48: '12rem',
    64: '16rem',
    auto: 'auto',
    '-1': '0.25rem',
    '-2': '0.5rem',
    '-3': '0.75rem',
    '-4': '1rem',
    '-5': '1.25rem',
    '-6': '1.5rem',
    '-8': '2rem',
    '-10': '2.5rem',
    '-12': '3rem',
    '-16': '4rem',
    '-20': '5rem',
    '-24': '6rem',
    '-32': '8rem',
    auto: 'auto'
  },

  /*
    |-----------------------------------------------------------------------------
    | Negative margin                https://tailwindcss.com/docs/negative-margin
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your negative margin utility sizes. These can
    | be percentage based, pixels, rems, or any other units. By default we
    | provide matching values to the padding scale since these utilities
    | generally get used together. You can, of course, modify these
    | values as needed.
    |
    | Class name: .-m{side?}-{size}
    |
    */

  negativeMargin: {
    px: '1px',
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.25rem',
    6: '1.5rem',
    7: '1.75rem',
    8: '2rem',
    9: '2.25rem',
    10: '2.5rem',
    12: '3rem',
    14: '3.5rem',
    16: '4rem',
    18: '4.5rem',
    20: '5rem',
    22: '5.5rem',
    24: '6rem',
    32: '8rem',
    48: '12rem',
    64: '16rem'
  },

  /*
    |-----------------------------------------------------------------------------
    | Shadows                                https://tailwindcss.com/docs/shadows
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your shadow utilities. As you can see from
    | the defaults we provide, it's possible to apply multiple shadows
    | per utility using comma separation.
    |
    | If a `default` shadow is provided, it will be made available as the non-
    | suffixed `.shadow` utility.
    |
    | Class name: .shadow-{size?}
    |
    */

  shadows: {
    default: '0 2px 4px 0 rgba(0,0,0,0.10)',
    md: '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
    lg: '0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08)',
    xl: '0 2px 10px 3px rgba(0, 0, 0, 0.21)',
    inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
    none: 'none',
    emboss: 'inset 0 -3px 0 rgba(0, 0, 0, .2)'
  },

  /*
    |-----------------------------------------------------------------------------
    | Z-index                                https://tailwindcss.com/docs/z-index
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your z-index utility values. By default we
    | provide a sensible numeric scale. You can, of course, modify these
    | values as needed.
    |
    | Class name: .z-{index}
    |
    */

  zIndex: {
    auto: 'auto',
    0: 0,
    10: 10,
    20: 20,
    30: 30,
    40: 40,
    50: 50
  },

  /*
    |-----------------------------------------------------------------------------
    | Opacity                                https://tailwindcss.com/docs/opacity
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your opacity utility values. By default we
    | provide a sensible numeric scale. You can, of course, modify these
    | values as needed.
    |
    | Class name: .opacity-{name}
    |
    */

  opacity: {
    0: '0',
    25: '.25',
    50: '.5',
    75: '.75',
    100: '1'
  },

  /*
    |-----------------------------------------------------------------------------
    | SVG fill                                   https://tailwindcss.com/docs/svg
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your SVG fill colors. By default we just provide
    | `fill-current` which sets the fill to the current text color. This lets you
    | specify a fill color using existing text color utilities and helps keep the
    | generated CSS file size down.
    |
    | Class name: .fill-{name}
    |
    */

  svgFill: {
    current: 'currentColor'
  },

  /*
    |-----------------------------------------------------------------------------
    | SVG stroke                                 https://tailwindcss.com/docs/svg
    |-----------------------------------------------------------------------------
    |
    | Here is where you define your SVG stroke colors. By default we just provide
    | `stroke-current` which sets the stroke to the current text color. This lets
    | you specify a stroke color using existing text color utilities and helps
    | keep the generated CSS file size down.
    |
    | Class name: .stroke-{name}
    |
    */

  svgStroke: {
    current: 'currentColor'
  },

  /*
    |-----------------------------------------------------------------------------
    | Modules                  https://tailwindcss.com/docs/configuration#modules
    |-----------------------------------------------------------------------------
    |
    | Here is where you control which modules are generated and what variants are
    | generated for each of those modules.
    |
    | Currently supported variants:
    |   - responsive
    |   - hover
    |   - focus
    |   - active
    |   - group-hover
    |
    | To disable a module completely, use `false` instead of an array.
    |
    */
  // stateVariants var used in style processing functions
  stateVariants: ['responsive', 'active', 'focus', 'hover'],
  modules: {
    appearance: ['responsive', 'active', 'focus'],
    backgroundAttachment: ['responsive'],
    backgroundColors: ['responsive', 'hover', 'active'],
    backgroundPosition: ['responsive'],
    backgroundRepeat: ['responsive'],
    backgroundSize: ['responsive'],
    borderColors: ['responsive', 'hover', 'active', 'focus'],
    borderRadius: ['responsive'],
    borderStyle: ['responsive'],
    borderWidths: ['responsive'],
    cursor: ['responsive'],
    display: ['responsive'],
    flexbox: ['responsive'],
    float: ['responsive'],
    fonts: ['responsive'],
    fontsData: ['responsive'],
    fontWeights: ['responsive', 'hover'],
    height: ['responsive'],
    leading: ['responsive'],
    lists: ['responsive'],
    margin: ['responsive'],
    maxHeight: ['responsive'],
    maxWidth: ['responsive'],
    minHeight: ['responsive'],
    minWidth: ['responsive'],
    negativeMargin: ['responsive'],
    opacity: ['responsive'],
    overflow: ['responsive'],
    objectFit: ['responsive'],
    objectPosition: ['responsive'],
    padding: ['responsive'],
    pointerEvents: ['responsive'],
    position: ['responsive'],
    resize: ['responsive'],
    shadows: ['responsive', 'active', 'focus'],
    svgFill: [],
    svgStroke: [],
    textAlign: ['responsive'],
    textColors: ['responsive', 'hover', 'active'],
    textSizes: ['responsive'],
    textStyle: ['responsive', 'hover'],
    tracking: ['responsive'],
    userSelect: ['responsive'],
    verticalAlign: ['responsive'],
    visibility: ['responsive'],
    whitespace: ['responsive'],
    width: ['responsive'],
    zIndex: ['responsive']
  },

  /*
    |-----------------------------------------------------------------------------
    | Plugins                                https://tailwindcss.com/docs/plugins
    |-----------------------------------------------------------------------------
    |
    | Here is where you can register any plugins you'd like to use in your
    | project. Tailwind's built-in `container` plugin is enabled by default to
    | give you a Bootstrap-style responsive container component out of the box.
    |
    | Be sure to view the complete plugin documentation to learn more about how
    | the plugin system works.
    |
    */

  plugins: [
    require('tailwindcss/plugins/container')({
      // center: true,
      // padding: '1rem',
    }),
    // require("tailwindcss-gradients")({
    //   variants: ["responsive", "hover"],
    //   directions: {
    //     t: "to top",
    //     tr: "to top right",
    //     r: "to right",
    //     br: "to bottom right",
    //     b: "to bottom",
    //     bl: "to bottom left",
    //     l: "to left",
    //     tl: "to top left"
    //   },
    //   gradients: {
    //     primary: [colors["primary"], "hsla(195, 100%, 59%, 1.00)"],
    //     secondary: [colors["secondary"], "hsla(320, 75%, 57%, 1.00)"],
    //     grey: [colors["grey-dark"], colors["grey"]],
    //     red: [colors["red"], colors["red-light"]],
    //     green: [colors["green"], colors["green-light"]],
    //     yellow: [colors["yellow"], colors["yellow-light"]]
    //   }
    // }),
    function({ addUtilities }) {
      const newUtilities = {
        '.w-1270px': {
          width: '1270px'
        },
        '.w-900px': {
          width: '900px'
        },
        '.w-600px': {
          width: '600px'
        }
      };

      addUtilities(newUtilities, {
        variants: ['responsive']
      });
    }
  ],

  /*
    |-----------------------------------------------------------------------------
    | Advanced Options         https://tailwindcss.com/docs/configuration#options
    |-----------------------------------------------------------------------------
    |
    | Here is where you can tweak advanced configuration options. We recommend
    | leaving these options alone unless you absolutely need to change them.
    |
    */

  options: {
    prefix: '',
    important: false,
    separator: ':'
  }
};
